import React, { Component } from 'react';
import ARSheetS from './ARSheetS';

class ARSheet extends Component {
    constructor(props) {
        super(props);
        const { auth } = props;
        const modules = [{
            key: 'arSheet',
            Content: ARSheetS,
        }
        ];

        this.modules = modules.filter(item => auth === undefined || auth[item.key] !== false);
    }
    render() {
        const { auth } = this.props;
        const modules = this.modules.map(item => {
            const { key, Content } = item;
            return <Content key={key} auth={auth ? auth[key] : auth} />;
        });
        return (
            <div className="pane">
                {modules}
            </div>
        );
    }
}

export default ARSheet;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/ARSheet/index.js